export default __webpack_public_path__ + "static/media/arrowBackDark.4ec1952c.svg";